<template>
	<div class="">
		<div class="config-row">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.graph_ttl?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.graph_ttl?.editable && editMode" type="button" class="btn btn-sm btn-secondary reset-btn"
							@click="resetToInitial('graph_ttl')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="input-group">
					<input type="number" class="form-control" v-model="config.graph_ttl" @input="updateConfig"
						:disabled="!fieldInfo?.graph_ttl?.editable || !editMode"
						:placeholder="fieldInfo?.graph_ttl?.editable ? fieldInfo?.graph_ttl?.placeholder : ''" />
					<div class="hours-box hours-box-with-right-border">
						<span class="hoursbox-text">h</span>
					</div>
				</div>
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Type
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.choose_cluster_type?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_type?.editable && editMode" type="button"
							class="btn btn-sm btn-secondary reset-btn" @click="resetToInitial('choose_cluster_type')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_type" @input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_type?.editable || !editMode"
					:placeholder="fieldInfo?.choose_cluster_type?.editable ? fieldInfo?.choose_cluster_type?.placeholder : ''" />
			</div>

			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Cluster Domain
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.choose_cluster_domain?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.choose_cluster_domain?.editable && editMode" type="button"
							class="btn btn-sm btn-secondary reset-btn" @click="resetToInitial('choose_cluster_domain')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<input type="text" class="form-control" v-model="config.choose_cluster_domain" @input="updateConfig"
					:disabled="!fieldInfo?.choose_cluster_domain?.editable || !editMode"
					:placeholder="fieldInfo?.choose_cluster_domain?.editable ? fieldInfo?.choose_cluster_domain?.placeholder : ''" />
			</div>
		</div>

		<div class="config-row mb-3 pb-1">
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Weightage Map
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_weightage_map?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_weightage_map?.editable && editMode" type="button"
							class="btn btn-sm btn-secondary reset-btn" @click="resetToInitial('create_cluster_weightage_map')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_weightage_map.length > 0">
							<div v-for="(item, index) in config.create_cluster_weightage_map" :key="index" 
								class="mb-2 item-wrapper"
								:class="{ 'item-added': isNewItem('create_cluster_weightage_map', index), 'item-removing': isRemovingItem('create_cluster_weightage_map', index) }">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="item.key" style="flex: 3;"
										@input="updateMapKey('create_cluster_weightage_map', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable || !editMode"
										placeholder="Key" />
									<input :type="'number'" class="form-control" :value="item.value" style="flex: 1;" placeholder="weightage"
										@input="updateMapValue('create_cluster_weightage_map', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_weightage_map?.editable || !editMode" />
									<button v-if="fieldInfo?.create_cluster_weightage_map?.editable && editMode" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntryWithAnimation('create_cluster_weightage_map', index)">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="text-danger" v-if="weightageMapError">{{ weightageMapError }}</span>
							</div>
							<div>
								<button v-if="fieldInfo?.create_cluster_weightage_map?.editable && editMode" type="button"
									class="btn btn-sm btn-primary mt-2 btn-primary"
									@click="addMapEntryWithAnimation('create_cluster_weightage_map')">
									<i class="fa fa-plus"></i> Add Entry
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="config-field">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						TTL Maps
						<span class="fa fa-circle-info text-muted ms-1"
							:title="fieldInfo?.create_cluster_ttl_maps?.tooltip" data-bs-toggle="tooltip"
							data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable && editMode" type="button"
							class="btn btn-sm btn-secondary reset-btn" @click="resetToInitial('create_cluster_ttl_maps')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_ttl_maps.length > 0">
							<div v-for="(item, index) in config.create_cluster_ttl_maps" :key="index" 
								class="mb-2 item-wrapper"
								:class="{ 'item-added': isNewItem('create_cluster_ttl_maps', index), 'item-removing': isRemovingItem('create_cluster_ttl_maps', index) }">
								<div class="input-group mb-1">
									<input type="text" class="form-control" :value="item.key" style="flex: 3;"
										@input="updateMapKey('create_cluster_ttl_maps', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable || !editMode" placeholder="Key" />
									<input :type="'number'" class="form-control" :value="item.value" style="flex: 1;" placeholder="ttl (-1 for inf)"
										@input="updateMapValue('create_cluster_ttl_maps', index, $event.target.value); updateConfig()"
										:disabled="!fieldInfo?.create_cluster_ttl_maps?.editable || !editMode" />
									<div :class="['hours-box', fieldInfo?.create_cluster_ttl_maps?.editable && editMode ? '' : 'hours-box-with-right-border']">
										<span class="hoursbox-text">h</span>
									</div>
									<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable && editMode" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeMapEntryWithAnimation('create_cluster_ttl_maps', index)">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<div>
								<span class="text-danger" v-if="ttlMapError">{{ ttlMapError }}</span>
							</div>
							<div>
								<button v-if="fieldInfo?.create_cluster_ttl_maps?.editable && editMode" type="button"
									class="btn btn-sm btn-primary mt-2 btn-primary"
									@click="addMapEntryWithAnimation('create_cluster_ttl_maps')">
									<i class="fa fa-plus"></i> Add Entry
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="config-row">
			<div class="config-field config-field-full">
				<div class="d-flex justify-content-between align-items-center">
					<label class="form-label fw-bold pt-1">
						Invalid IDs
						<span class="fa fa-circle-info text-muted ms-1" :title="fieldInfo?.create_cluster_invalid_ids?.tooltip"
							data-bs-toggle="tooltip" data-bs-placement="right"></span>
					</label>
					<div class="pb-1">
						<button type="button" class="btn btn-sm btn-secondary reset-btn" v-if="fieldInfo?.create_cluster_invalid_ids?.editable && editMode"
							@click="resetToInitial('create_cluster_invalid_ids')">
							<i class="fa fa-rotate-left"></i> Reset
						</button>
					</div>
				</div>
				<div class="card">
					<div class="card-body">
						<div v-if="config.create_cluster_invalid_ids?.length > 0">
							<div v-for="(item, index) in config.create_cluster_invalid_ids" :key="index" 
								class="mb-2 item-wrapper"
								:class="{ 'item-added': isNewItem('create_cluster_invalid_ids', index), 'item-removing': isRemovingItem('create_cluster_invalid_ids', index) }">
								<div class="input-group">
									<input type="text" class="form-control" v-model="config.create_cluster_invalid_ids[index]"
										@input="updateConfig" :disabled="!fieldInfo?.create_cluster_invalid_ids?.editable || !editMode"
										:placeholder="item == null ? 'null' : 'invalid value'" />
									<button v-if="fieldInfo?.create_cluster_invalid_ids?.editable && editMode" type="button"
										class="btn btn-sm btn-outline-danger"
										@click="removeArrayItemWithAnimation('create_cluster_invalid_ids', index)">
										<i class="fa fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<p class="text-muted">No data found!</p>
						</div>
						<div class="d-flex justify-content-end align-items-center">
							<button v-if="fieldInfo?.create_cluster_invalid_ids?.editable && editMode" type="button"
								class="btn btn-sm btn-primary mt-2 btn-primary"
								@click="addArrayItemWithAnimation('create_cluster_invalid_ids')">
								<i class="fa fa-plus"></i> Add ID
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ClusterConfigEasyMode',
	data() {
		return {
			config: {
				graph_ttl: "",
				create_cluster_weightage_map: {},
				create_cluster_ttl_maps: {},
				create_cluster_invalid_ids: [],
				choose_cluster_type: "",
				choose_cluster_domain: ""
			},
			isLoadingFromParent: false,
			ttlMapError: "",
			weightageMapError: "",
			newItemIndexes: {
				create_cluster_weightage_map: new Set(),
				create_cluster_ttl_maps: new Set(),
				create_cluster_invalid_ids: new Set()
			},
			removingItemIndexes: {
				create_cluster_weightage_map: new Set(),
				create_cluster_ttl_maps: new Set(),
				create_cluster_invalid_ids: new Set()
			}
		};
	},
	props: {
		modelValue: {
			type: Object,
			default: () => ({})
		},
		fieldInfo: {
			type: Object,
			default: () => ({})
		},
		cleanConfigFn: {
			type: Function,
			required: true
		},
		editMode: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		modelValue: {
			handler(newVal, oldVal) {
				// Only load config if it's actually different (not just a reference change)
				// This prevents overwriting local changes when switching tabs
				if (newVal && typeof newVal === 'object' && Object.keys(newVal).length > 0) {
					// Check if the config has actually changed by comparing key values
					if (!oldVal || !this.isConfigEqual(newVal, oldVal)) {
						this.isLoadingFromParent = true;
						this.loadConfig(newVal);
						this.$nextTick(() => {
							this.isLoadingFromParent = false;
						});
					}
				}
			},
			deep: true,
			immediate: false
		}
	},
	beforeMount() {
		if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
			this.loadConfig(this.modelValue);
		}
	},
	methods: {
		isConfigEqual(config1, config2) {
			// Deep comparison to check if configs are actually different
			if (!config1 || !config2) return false;
			const keys1 = Object.keys(config1);
			const keys2 = Object.keys(config2);
			if (keys1.length !== keys2.length) return false;

			for (let key of keys1) {
				if (JSON.stringify(config1[key]) !== JSON.stringify(config2[key])) {
					return false;
				}
			}
			return true;
		},
		updateConfig() {
			// Emit updated config to parent to maintain state
			// Don't emit if we're currently loading from parent (prevents infinite loop)
			if (!this.isLoadingFromParent) {
				const configObj = this.cleanConfigFn(this.config);
				this.$emit('update:modelValue', configObj);
				this.$emit('invalidValuesChange', this.config.create_cluster_invalid_ids);
			}
		},
		loadConfig(value) {
			if (!value || typeof value !== 'object') {
				return;
			}

			// Initialize config with prop values or defaults
			const weightageMap = [];
			if (value.create_cluster_weightage_map && Array.isArray(value.create_cluster_weightage_map)) {
				value.create_cluster_weightage_map.forEach(item => {
					let key = item.key;
					let val = item.value;

					try {
						if (val === true || val === false || val === null || val === undefined) {
							val = 0;
						} else if (typeof val === 'string') {
							val = val.trim();
							if (val.toLowerCase() == "inf") {
								val = -1;
							} else if (val.match(/^\d+[hH]$/)) {
								if (val.includes('.')) {
									val = parseFloat(val);
								} else {
									val = parseInt(val);
								}
							} else {
								val = isNaN(val) ? "" : Number(val);
							}
						} else {
							val = isNaN(val) ? "" : Number(val);
						}
					} catch (e) {
						console.log("Error parsing value in weightage map for key(", key, ") : ", e);
						val = 0;
					}

					weightageMap.push({
						key: key,
						value: val
					});
				});
			}

			const ttlMaps = [];
			if (value.create_cluster_ttl_maps && Array.isArray(value.create_cluster_ttl_maps)) {
				value.create_cluster_ttl_maps.forEach(item => {
					let key = item.key;
					let val = item.value;

					try {
						if (val === true || val === false || val === null || val === undefined) {
							val = 0;
						} else if (typeof val === 'string') {
							val = val.trim();
							if (val.toLowerCase() == "inf") {
								val = -1;
							} else if (val.match(/^\d+[hH]$/)) {
								if (val.includes('.')) {
									val = parseFloat(val);
								} else {
									val = parseInt(val);
								}
							} else {
								val = isNaN(val) ? "" : Number(val);
							}
						} else {
							val = isNaN(val) ? "" : Number(val);
						}
					} catch (e) {
						console.log("Error parsing value in ttl map for key(", key, ") : ", e);
						val = 0;
					}

					ttlMaps.push({
						key: key,
						value: val
					});
				});
			}

			let graph_ttl = "";
			if (value.graph_ttl) {
				try {
					if (typeof value.graph_ttl === 'number') {
						graph_ttl = value.graph_ttl;
					} else if (typeof value.graph_ttl === 'string') {
						let val = value.graph_ttl.trim();
						if (val.toLowerCase() == "inf") {
							val = -1;
						} else if (val.match(/^\d+[hH]$/)) {
							if (val.includes('.')) {
								val = parseFloat(val);
							} else {
								val = parseInt(val);
							}
						} else {
							val = isNaN(val) ? "" : Number(val);
						}
						graph_ttl = val;
					}
				} catch (e) {
					console.error("Error parsing value in graph ttl : ", e);
				}
			}

			this.config = {
				graph_ttl: graph_ttl,
				create_cluster_weightage_map: weightageMap,
				create_cluster_ttl_maps: ttlMaps,
				choose_cluster_type: value.choose_cluster_type || "",
				choose_cluster_domain: value.choose_cluster_domain || "",
				create_cluster_invalid_ids: value.create_cluster_invalid_ids || []
			};
			
			// Check for duplicates in ttl maps and weightage maps since they are implemented as arrays
			this.checkDuplicates("create_cluster_weightage_map");
			this.checkDuplicates("create_cluster_ttl_maps");
		},
		resetToInitial(fieldName) {
			if (this.modelValue && typeof this.modelValue === 'object' && Object.keys(this.modelValue).length > 0) {
				let config = JSON.parse(JSON.stringify(this.modelValue));
				config[fieldName] = JSON.parse(JSON.stringify(this.fieldInfo[fieldName].initialValue));
				this.loadConfig(config);
				this.updateConfig();
			}
		},
		isNewItem(fieldName, index) {
			return this.newItemIndexes[fieldName].has(index);
		},
		isRemovingItem(fieldName, index) {
			return this.removingItemIndexes[fieldName].has(index);
		},
		addMapEntryWithAnimation(fieldName) {
			if (this.config[fieldName].some(item => item.key === "")) {
				return;
			}
			const newIndex = this.config[fieldName].length;
			this.config[fieldName].push({
				key: "",
				value: 0
			});
			
			// Mark as new item
			this.newItemIndexes[fieldName].add(newIndex);
			
			// Remove the animation class after animation completes
			setTimeout(() => {
				this.newItemIndexes[fieldName].delete(newIndex);
			}, 500);
			
			this.updateConfig();
		},
		addMapEntry(fieldName) {
			if (this.config[fieldName].some(item => item.key === "")) {
				return;
			}
			this.config[fieldName].push({
				key: "",
				value: 0
			});
		},
		updateMapKey(fieldName, index, newKey) {
			const row = this.config[fieldName][index];
			if (this.config[fieldName][index]) {
				row.key = newKey;
			}
		},
		updateMapValue(fieldName, index, value) {
			const row = this.config[fieldName][index];
			if (row) {
				row.value = value;
			}
		},
		removeMapEntryWithAnimation(fieldName, index) {
			if (index < 0 || index >= this.config[fieldName].length) return;
			
			// Mark as removing
			this.removingItemIndexes[fieldName].add(index);
			
			// Wait for animation to complete before actually removing
			setTimeout(() => {
				this.removingItemIndexes[fieldName].delete(index);
				this.config[fieldName].splice(index, 1);
				this.updateConfig();
			}, 400);
		},
		removeMapEntry(fieldName, index) {
			if (index < 0 || index >= this.config[fieldName].length) return;
			this.config[fieldName].splice(index, 1);
		},
		addArrayItemWithAnimation(fieldName) {
			if (!Array.isArray(this.config[fieldName])) {
				this.config[fieldName] = [];
			}
			const newIndex = this.config[fieldName].length;
			this.config[fieldName].push("");
			
			// Mark as new item
			this.newItemIndexes[fieldName].add(newIndex);
			
			// Remove the animation class after animation completes
			setTimeout(() => {
				this.newItemIndexes[fieldName].delete(newIndex);
			}, 500);
			
			this.updateConfig();
		},
		addArrayItem(fieldName) {
			if (!Array.isArray(this.config[fieldName])) {
				this.config[fieldName] = [];
			}
			this.config[fieldName].push("");
		},
		removeArrayItemWithAnimation(fieldName, index) {
			// Mark as removing
			this.removingItemIndexes[fieldName].add(index);
			
			// Wait for animation to complete before actually removing
			setTimeout(() => {
				this.removingItemIndexes[fieldName].delete(index);
				this.config[fieldName].splice(index, 1);
				this.updateConfig();
			}, 400);
		},
		removeArrayItem(fieldName, index) {
			this.config[fieldName].splice(index, 1);
		},
		checkDuplicates(fieldName) {
			const uniqueMap = new Map();
			const duplicateKeys = new Set();
			this.config[fieldName].forEach(item => {
				if (uniqueMap.has(item.key)) {
					duplicateKeys.add(item.key);
					return true; // Found a duplicate
				} else {
					uniqueMap.set(item.key, true);
					return false;
				}
			});
			if (duplicateKeys.size > 0) {
				if (fieldName == "create_cluster_weightage_map") this.weightageMapError = `Duplicate ${duplicateKeys.size == 1 ? "key" : "keys"} found : ` + Array.from(duplicateKeys).map(key => `'${key}'`).join(", ");
				else this.ttlMapError = `Duplicate ${duplicateKeys.size == 1 ? "key" : "keys"} found : ` + Array.from(duplicateKeys).map(key => `'${key}'`).join(", ");
			} else {
				if (fieldName == "create_cluster_weightage_map") this.weightageMapError = "";
				else this.ttlMapError = "";
			}
		},
	},
	emits: ["update:modelValue", "resetToInitial", "invalidValuesChange"],
};
</script>

<style scoped>
.config-row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	margin-bottom: 1rem;
}

.config-row:first-child .config-field {
	flex: 1 1 calc(33.333% - 0.67rem);
	min-width: 200px;
}

.config-row:nth-child(2) .config-field {
	flex: 1 1 calc(50% - 0.5rem);
	min-width: 300px;
}

.config-field {
	padding: 0.7rem;
	background-color: #fafafa;
	border-radius: 4px;
	box-sizing: border-box;
	border: 1px solid #838383;
	box-shadow: 4px 4px 4px rgb(204, 204, 204);
}

.config-field-full {
	flex: 1 1 100%;
}

@media (max-width: 992px) {
	.config-row:first-child .config-field {
		flex: 1 1 calc(50% - 0.5rem);
	}
}

@media (max-width: 768px) {

	.config-row:first-child .config-field,
	.config-row:nth-child(2) .config-field {
		flex: 1 1 100%;
	}
}

.input-group {
	display: flex;
	align-items: stretch;
}

.input-group .form-control {
	flex: 1;
}

.form-label {
	font-size: 0.75rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.form-select {
	max-width: 100px;
	background-color: #f6f6f6;
}

.card {
	margin-bottom: 0rem;
}

.hours-box {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 25px;
	background-color: #f6f6f6;
	border: 1px solid #d3d8da;
	border-left: none;
}

.hours-box-with-right-border {
	border-right: 1px solid #d3d8da;
	border-radius: 0 4px 4px 0 !important;
}

.hoursbox-text {
	font-weight: bold;
	color: #666;
}

.reset-btn {
	height: 25px;
	font-size: 0.7rem;
	margin-bottom: 3.5px;
	/* align items center */
}

/* Animation styles for item wrapper */
.item-wrapper {
	transition: all 0.4s ease;
}

/* Add item animation - scales in and fades in */
.item-added {
	animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
	0% {
		opacity: 0;
		transform: scale(0.8) translateY(-10px);
	}
	50% {
		transform: scale(1.05);
	}
	100% {
		opacity: 1;
		transform: scale(1) translateY(0);
	}
}

/* Remove item animation - slides out and fades */
.item-removing {
	animation: slideOut 0.4s ease forwards;
}

@keyframes slideOut {
	0% {
		opacity: 1;
		transform: translateX(0) scale(1);
		max-height: 100px;
		margin-bottom: 0.5rem;
	}
	100% {
		opacity: 0;
		transform: translateX(100px) scale(0.9);
		max-height: 0;
		margin-bottom: 0;
		padding-top: 0;
		padding-bottom: 0;
	}
}
</style>